import styled from 'styled-components';
import {
  AssessmentTestStep,
  AssessmentTestStepAnswer,
} from '../../../../api/admin';
import {
  MarkdownWrapper,
  StickyHeaderModal,
  computeTimeFromIntervals,
} from '../common';
import { H5 } from '../../../elements/Text';
import {
  renderSectionAnswer,
  TextInputAnswer,
  BasicPill,
  BadgesRow,
  TimeTakenPill,
} from './StepModalComponents';
import { typeLabels } from './QuestionTypeCell';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px 0;
`;

const SectionTitle = styled(H5)`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0;
`;

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export default function ScenarioStepModal({
  isOpen,
  onClose,
  step,
  answer,
}: {
  isOpen: boolean;
  onClose: () => void;
  step: AssessmentTestStep;
  answer: AssessmentTestStepAnswer | undefined;
}) {
  if (!isOpen) {
    return null;
  }

  const introductionTime = answer?.introduction?.timeIntervals
    ? computeTimeFromIntervals(answer.introduction.timeIntervals)
    : 0;

  return (
    <StickyHeaderModal title={step.label} onClose={onClose}>
      <Content>
        {/* Introduction */}
        {step.introduction && (
          <div>
            <SectionTitle>Introduction</SectionTitle>
            {introductionTime > 0 && (
              <BadgesRow>
                <TimeTakenPill timeTaken={introductionTime} />
              </BadgesRow>
            )}
            <SectionContent>
              <MarkdownWrapper md={step.introduction} />
            </SectionContent>
          </div>
        )}

        {/* Questions and Answers */}
        {step.sections.map((section, index) => {
          const sectionAnswer = answer?.sections.find(
            (a) => a.id === section.id
          );

          const sectionTime = sectionAnswer?.timeIntervals
            ? computeTimeFromIntervals(sectionAnswer.timeIntervals)
            : 0;

          return (
            <div key={section.id}>
              <SectionTitle>Question {index + 1}</SectionTitle>
              <BadgesRow>
                {sectionTime > 0 && <TimeTakenPill timeTaken={sectionTime} />}
                <BasicPill>
                  {typeLabels[section.type] || section.type}
                </BasicPill>
                {section.followUpContent && <BasicPill>Follow-up</BasicPill>}
              </BadgesRow>
              <SectionContent>
                <MarkdownWrapper md={section.content ?? ''} />
                {renderSectionAnswer(sectionAnswer, section)}
                {section.followUpContent && (
                  <>
                    <MarkdownWrapper md={section.followUpContent} />
                    <TextInputAnswer
                      answer={sectionAnswer?.followUpAnswer ?? ''}
                    />
                  </>
                )}
              </SectionContent>
            </div>
          );
        })}
      </Content>
    </StickyHeaderModal>
  );
}
